import { render } from "./PlatRole.vue?vue&type=template&id=4c5e3ce4"
import script from "./PlatRole.vue?vue&type=script&lang=js"
export * from "./PlatRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__